// extracted by mini-css-extract-plugin
module.exports = {"lastChatDateInfo":"styles_lastChatDateInfo__MR9lq","clockIcon":"styles_clockIcon__2tjLh"};